import { buildDrupalMetatags } from "./../buildDrupalMetatags/index.js";
import {
  useNuxtApp,
  useHead,
  computed,
  navigateTo,
  createError,
  watch
} from "#imports";
export async function useDrupalRoute(queryInput, options) {
  const app = useNuxtApp();
  const query = computed(() => {
    if (!queryInput) {
      return;
    }
    if (queryInput !== null && "value" in queryInput && queryInput.value) {
      return queryInput.value;
    }
    if ("route" in queryInput) {
      return queryInput;
    }
  });
  const metatags = computed(
    () => buildDrupalMetatags(query.value?.route?.metatags)
  );
  useHead(metatags);
  const drupalRoute = computed(() => ({
    name: query.value?.route?.routeName || void 0,
    entityBundle: query.value?.route?.drupalRouteEntity?.entityBundle || void 0,
    entityType: query.value?.route?.drupalRouteEntity?.entityTypeId || void 0,
    entityId: query.value?.route?.drupalRouteEntity?.id || void 0,
    entityUuid: query.value?.route?.drupalRouteEntity?.uuid || void 0
  }));
  const entity = computed(
    () => query.value?.route?.entity || void 0
  );
  const hookPayload = computed(() => ({
    drupalRoute: drupalRoute.value,
    metatags: metatags.value
  }));
  const handleRoute = async () => {
    if (query.value?.route && "redirect" in query.value.route) {
      await navigateTo(query.value.route.path, {
        redirectCode: query.value.route.redirect?.statusCode ?? 301,
        replace: true,
        external: true
      });
      return;
    }
    if ((!query.value?.route || !entity.value) && !options?.noError) {
      throw createError({
        statusCode: 404,
        statusMessage: "Page not found",
        fatal: true
      });
    }
    await app.callHook("drupal-route", hookPayload.value);
  };
  if (import.meta.client) {
    watch(query, handleRoute);
  }
  await handleRoute();
  return {
    entity,
    drupalRoute,
    metatags
  };
}
